import React from "react";
import Tracks from "../Tracks/Tracks";
import Input from "../Tracks/Input";

const Index = () => {
  return (
    <React.Fragment>
      <Input />
      <Tracks />
    </React.Fragment>
  );
};

export default Index;
